<script setup lang="ts">
import { Editor } from "@tiptap/vue-3";
import SvgIcon from "~/components/Common/SvgIcon.vue";

export interface IActions {
  name: string;
  icon: string;
  label: string;
  function: Function;
  shortcut?: string;
}

defineProps({
  actions: {
    type: Object as PropType<IActions[]>,
  },
  editor: Editor,
});
</script>
<template>
  <div class="group-container">
    <div
      v-for="(action, index) in actions"
      :key="index"
      v-if="actions?.length"
      class="button-container"
      :class="{ 'is-active': editor?.isActive(action.name) }"
      @click="action.function()"
    >
      <!-- <Tooltip :position="'top-mid'" append-to-body minified :forcePositionTop="13">
                <template #img> -->
      <div :class="{ 'is-active': editor?.isActive(action.name) }">
        <SvgIcon
          class="svg-default-icon"
          :class="{ 'is-active': editor?.isActive(action.name) }"
          :name="action.icon"
        ></SvgIcon>
      </div>
    </div>
  </div>
</template>
<style scoped lang="scss">
.group-container {
  @apply flex;
}

.button-container {
  @apply flex flex-row justify-center items-center rounded-[8px] w-fit;
  height: 36px;
  min-width: 36px;
  cursor: pointer;
  border: 1px solid var(--grey-lightest);
  color: var(--grey-lightest);
  transition: border-color 0.3s;

  &:hover,
  &:hover * {
    background-color: var(--grey-light);
    border-color: var(--grey-medium-light);
  }

  &:active,
  &:active * {
    border-color: var(--blue-deep-dark);
    color: var(--blue-deep-dark);
  }

  &.is-active {
    border-color: var(--primary-blue-color);
    color: var(--primary-blue-color);
  }

  &.is-active:hover {
    border-width: 1.5px;
    border-color: var(--blue-deep-dark);
    color: var(--blue-deep-dark);
    background-color: var(--grey-light);
  }

  &.is-active:hover * {
    border-color: var(--blue-deep-dark);
    color: var(--blue-deep-dark);
    background-color: var(--grey-light);
  }

  &:first-child {
    @apply rounded-r-none;
  }

  &:last-child {
    @apply rounded-l-none;
  }

  &:not(:first-child):not(:last-child) {
    @apply rounded-none;
  }

  &:not(:first-child) {
    margin-left: -1px;
  }

  &:hover,
  &.is-active {
    position: relative;
    z-index: 1;
  }

  /* Handle the case where a hovered button is next to an active button */
  // &.is-active + &:hover,
  // &:hover + .is-active {
  //     border-left: none;
  // }
}

.svg-default-icon {
  @apply w-[16px] h-[16px] text-secondary-color;

  &.is-active {
    color: var(--primary-blue-color);
  }
}
</style>
